import PageHeader from '../../../shared/components/PageHeader';
import { getLegalContent, type LegalPageKind } from './constants/legalContent';
import LegalSection from './Parts/LegalSection';

type LegalPageProps = {
  back: () => void;
  kind: LegalPageKind;
  t: any;
};

export default function LegalPage({ back, kind, t }: LegalPageProps) {
  const content = getLegalContent(t.locale || 'en', kind);

  return (
    <PageHeader
      back={back}
      className="legal-page"
      eyebrow={content.eyebrow}
      title={content.title}
      subtitle={content.subtitle}
    >
      <article className="legal-card">
        <p className="legal-updated">{content.updated}</p>
        {content.sections.map((section) => (
          <LegalSection
            key={section.title}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        ))}
      </article>
    </PageHeader>
  );
}
